import React from 'react';
import { useLanguage } from '../context/LanguageContext';
const navLinks = [{
  key: 'nav.about',
  href: '#about'
}, {
  key: 'nav.services',
  href: '#services'
}, {
  key: 'nav.experience',
  href: '#experience'
}, {
  key: 'nav.approach',
  href: '#approach'
}, {
  key: 'nav.advantages',
  href: '#advantages'
}, {
  key: 'nav.faq',
  href: '#faq'
}, {
  key: 'nav.contact',
  href: '#contact'
}];
const serviceLinks = ['services.automation.title', 'services.electrical.title', 'services.lowcurrent.title'];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-[#12141a] border-t border-slate-800/50" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-192">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-193">
          {/* Company */}
          <div data-id="element-194">
            <div className="mb-4" data-id="element-195">
              <span className="text-sm font-bold tracking-[0.2em] uppercase text-slate-100" data-id="element-196">
                Power <span className="text-electric" data-id="element-197">Logic</span>
              </span>
            </div>
            <p className="text-xs text-slate-500 leading-relaxed" data-id="element-198">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-199">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-4" data-id="element-200">
              {t('footer.quicklinks')}
            </h4>
            <ul className="space-y-2" data-id="element-201">
              {navLinks.map(link => <li key={link.key} data-id="element-202">
                  <a href={link.href} className="text-xs text-slate-500 hover:text-electric transition-colors duration-200" data-id="element-203">
                    {t(link.key)}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-204">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-4" data-id="element-205">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2" data-id="element-206">
              {serviceLinks.map(key => <li key={key} data-id="element-207">
                  <a href="#services" className="text-xs text-slate-500 hover:text-electric transition-colors duration-200" data-id="element-208">
                    {t(key)}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-209">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-4" data-id="element-210">
              {t('footer.contacts')}
            </h4>
            <ul className="space-y-2 text-xs text-slate-500" data-id="element-211">
              <li data-id="element-212">{t('contact.info.director')}</li>
              <li data-id="element-213">{t('contact.info.phone')}</li>
              <li data-id="element-214">{t('contact.info.email')}</li>
              <li data-id="element-215">{t('contact.info.location')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-216">
          <p className="text-xs text-slate-600" data-id="element-217">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6" data-id="element-218">
            <a href="#" className="text-xs text-slate-600 hover:text-slate-400 transition-colors duration-200" data-id="element-219">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-xs text-slate-600 hover:text-slate-400 transition-colors duration-200" data-id="element-220">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}